<script>
import axios from "axios";
// import simplebar from "simplebar-vue";
import { Translator } from 'vue-google-translate';
import { layoutComputed } from "@/state/helpers";
import { productMethods, productComputed, categorieComputed, categorieMethods } from "@/state/helpers";

export default {
  data() { return { 
    userData: JSON.parse(localStorage.getItem("user")),
    token: localStorage.getItem("token"),
    arrayOfCountries: [
        {  code: 'en|en',  title: 'English',  },
        {  code: 'en|fr',  title: 'French',  },
        {  code: 'en|ar',  title: 'Arabic',  },
        {  code: 'en|es',  title: 'Spanish',  },
        {  code: 'en|de',  title: 'German',  }],
   }; },
  components: {Translator},
  computed: {
    ...productComputed,
    ...categorieComputed,
    ...layoutComputed,
    limitedProducts() {return this.products.slice(0, 8);},
  },
  created() {
    this.fetchCategories();
  },
  methods: {
    ...categorieMethods,
    ...productMethods,
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    customEvent() {
      this.$router.push(this.$route.query.redirectFrom || {name: "default",})
    },
    toggleMenu() {
      let element = document.getElementById("topnav-menu-content");
      element.classList.toggle("show");
    },
    fetchCart(){
      if (this.token!=null) {
        this.fetchCarts();
      }
    },
    getFiles(name){
      let url = axios.defaults.baseURL;
      let imagelink = (url).slice(0,-3)+"products/"+name;
      return imagelink;
    },
    getPhotos(name){
      let url = axios.defaults.baseURL;
      let imagelink = (url).slice(0,-3)+"category/"+name;
      return imagelink;
    },
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    filterProduct(e) {
      const search = e.target.value;
      this.filterProducts({search:search});
    },
   }
};
</script>

<template>
  <!-- <header id="page-topbar" style="background-color:#564ab1"> -->
    <header id="page-topbar" style="background-color:#E6FDFF">
    <div class="navbar-header">
      <div class="d-flex">
        <div class="navbar-brand-box">
          <router-link to="/" class="logo logo-light">
            <span class="logo-sm"><img src="@/assets/images/logo2.png" height="30px" style="border-radius: 5%;"/></span>
            <span class="logo-lg"><img src="@/assets/images/logo2.png" height="50px" style="border-radius: 5%;"/></span>
          </router-link>
        </div>

        <b-dropdown variant="white" class="dropdown-mega" toggle-class="header-item" menu-class="dropdown-megamenu">
          <template v-slot:button-content><b-button class="btn-outline-primary" variant="white"> Categories <i class="mdi mdi-chevron-down"></i></b-button>
          </template>
          <div class="row">
            <div v-for="item in categories" :key="item.id" class="col-sm-3 col-6 mb-2">
              <h5 class="font-size-14 mt-0">{{ item.name }}</h5>
              <div class="row">
                <div class="col-md-3 pe-0">
                  <img :src="getPhotos(item.photo)" height="50px"/>
                </div>
                <div class="col-md-9 ps-1">
                  <div v-for="item in item.subcategories" :key="item.id" class="mb-1">
                    <router-link :to="{ path: '/category', query: { id: item.id, name:item.name }}" style="font-size: 11px;" class="text-dark"><i class="mdi mdi-arrow-right"></i> {{ item.name }} </router-link>
                  </div>
              </div>
              </div>
            </div>
          </div> 
        </b-dropdown>
      </div>

      <div class="search-box me-2">
        <div class="position-relative">
          <input type="text" readonly v-b-modal.search-box class="form-control border-1" placeholder="Search Ovvura" @input="searchFilter($event)"/>
          <i class="bx bx-search-alt search-icon"></i>
        </div>
      </div>

      <div class="d-flex">
        <b-dropdown right variant="black" toggle-class="header-item">
          <template v-slot:button-content>
            <b-button variant="primary" size="sm"><i class="mdi mdi-google-translate me-1"></i> Translate </b-button>
          </template>
          <Translator :countries="arrayOfCountries" @on-country-click="customEvent" />
        </b-dropdown>

        <button id="toggle" type="button" class="btn btn-sm me-2 font-size-16 d-lg-none header-item" @click="toggleMenu"><i class="fa fa-fw fa-bars text-success"></i></button>
        <span v-if="token==null">
          <a href="/login" class="header-item"><button type="button" class="btn pe-0"><i class="mdi mdi-account-circle text-danger mdi-36px"></i></button><span class="h6 d-none d-xl-inline-block text-danger">Login</span></a>
        </span>
        <span v-else>
          <b-dropdown right variant="black" toggle-class="header-item">
            <template v-slot:button-content>
              <img class="rounded-circle header-profile-user" src="@/assets/images/user.png" />
              <span class="d-none d-xl-inline-block h6 text-danger ms-1">{{ userData.first_name.charAt(0) }} {{ userData.last_name.charAt(0) }}</span>
              <i class="mdi mdi-chevron-down text-danger d-none d-xl-inline-block"></i>
            </template>
             <router-link to="/dashboard" class="fw-medium dropdown-item text-success"><i class="mdi mdi-account me-1"></i> My Account</router-link> 
            <a href="/logout" class="dropdown-item text-success"><i class="bx bx-power-off font-size-16 align-middle me-1 text-success"></i> logout</a>
          </b-dropdown>
        </span>
        <div class="d-none d-md-block my-auto"><router-link to="/cart">
            <button type="button" class="btn">
              <i class="mdi mdi-basket mdi-36px text-danger toggle-right"></i>
            </button>
        </router-link></div>

      </div>
    </div>

    <b-modal id="search-box" size="lg" centered title="Search Service" title-class="font-18" hide-footer>

      <div class="search-box me-2">
        <div class="position-relative">
          <input type="text" class="form-control border-3" placeholder="Search..." @input="filterProduct($event)"/>
          <i class="bx bx-search-alt search-icon"></i>
        </div>
      </div>

      <div class="row">
        <div v-for="data in limitedProducts" :key="data.id" class="col-6 col-md-3">
          <router-link tag="a" class="text-dark" :to="{ path: '/product', query: { id: data.product_id }}">
          <div class="card m-0 mt-2 shadow-lg">
            <div class="card-body p-2 d-flex">
              <!-- <div><img :src="getFiles(data.photo)" height="50px"/></div> -->
              <div class="ps-1">
                <h6 class="text-truncate mb-1">{{ data.name }}</h6>
                <span class="my-0"><b>Price: {{ commas(data.price) }} AED</b></span><br>
                <span class="small">Category: {{ data.category.name }}</span>
              </div>
            </div>
          </div>
          </router-link>
        </div>
        <div v-if="products.length<=0" class="p-5 text-center">
          <i class="bx bx-search-alt fa-3x"></i><br> No Product/ Service Found
        </div>
      </div>
    </b-modal>
  </header>
</template>
